import { useField, useForm as useVeeValidateForm } from "vee-validate";
import { useProvideFormContext } from "./useFormContext";

export const useForm: typeof useVeeValidateForm = options => {
  const form = useVeeValidateForm(options);
  useProvideFormContext();

  const serverError = useField("server");
  // @ts-expect-error Error due to
  const handleSubmit: typeof form.handleSubmit = (cb, onValidationError) => {
    return form.handleSubmit(async (values, ctx) => {
      try {
        await cb(values, ctx);
      } catch (error) {
        if (error instanceof Error) {
          serverError.setErrors(error.message);
        }
        throw error;
      }
    }, onValidationError);
  };

  handleSubmit.withControlled = form.handleSubmit.withControlled;

  return {
    ...form,
    handleSubmit,
  };
};
